import React from 'react';
import { Modal, Button } from '../ui-kit';

const WidgetSettings = props => (
  <Modal size="xl" show={props.show} onHide={() => props.setShow(false)}>
    <Modal.Header closeButton>
      <Modal.Title>{I18n.t('settings')}</Modal.Title>
    </Modal.Header>
    {/* Provide a minimum height for the settings modal, as react select doesn't change the modal to fit overflow */}
    <Modal.Body style={{ minHeight: '300px' }}>{props.children}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={() => props.setShow(false)}>
        {I18n.t('close')}
      </Button>
      <Button variant="success" onClick={() => props.saveSettings()}>
        {I18n.t('save')}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default WidgetSettings;
